var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 35,
    fill: "#AFB6C6",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4285 78.5373C48.5748 82.6593 49.9028 83 51 83C52.0972 83 53.4251 82.6593 57.5715 78.5373C60.1968 75.9269 63.0776 72.6357 65.6776 69.2712C70.8425 62.5892 77 52.9909 77 45.2088C77 30.7573 65.3364 19 51 19C36.6636 19 25 30.7573 25 45.2088C25 52.9909 31.1575 62.5892 36.3223 69.2712C38.9243 72.6357 41.8031 75.9269 44.4285 78.5373ZM30.6251 45.2088C30.6251 33.884 39.7654 24.6703 51 24.6703C62.2346 24.6703 71.3749 33.884 71.3749 45.2088C71.3749 55.351 55.5454 73.287 51 76.9215C46.4545 73.2883 30.6251 55.3523 30.6251 45.2088ZM36.9343 45.2079C36.9343 53.0247 43.2426 59.3836 50.9971 59.3836C58.7516 59.3836 65.0598 53.0247 65.0598 45.2079C65.0598 37.3911 58.7516 31.0322 50.9971 31.0322C43.2426 31.0322 36.9343 37.3911 36.9343 45.2079ZM46.3094 38.1359C47.6969 37.2013 49.3283 36.7025 50.9971 36.7025C53.2339 36.7058 55.3781 37.603 56.9598 39.1973C58.5415 40.7917 59.4315 42.9532 59.4347 45.2079C59.4347 46.8901 58.9399 48.5346 58.0127 49.9333C57.0856 51.332 55.7678 52.4222 54.226 53.0659C52.6843 53.7097 50.9877 53.8781 49.351 53.5499C47.7142 53.2217 46.2108 52.4117 45.0308 51.2222C43.8507 50.0327 43.0471 48.5171 42.7216 46.8673C42.396 45.2174 42.5631 43.5072 43.2017 41.953C43.8403 40.3989 44.9218 39.0705 46.3094 38.1359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading1);
export default __webpack_public_path__ + "static/media/loading-1.d5c31cb6f3e7f28409e36104b5b70456.svg";
export { ForwardRef as ReactComponent };